<template>
    <div class="metodo-avaliacao-curso-editor">
        <div style="color: #909399; font-size: 12px; margin-bottom: 10px;">
            Vale para turmas novas. Para aplicar às turmas existentes, rodar <code>php artisan diario:aplicar-parametros-turma --metodo</code> (turmas com nota ou parecer lançado não mudam).
        </div>

        <div v-if="carregando" class="u-text-center u-mt-10">
            <img src="/public/img/loading-bar.gif" />
        </div>

        <template v-else>
            <div v-for="c in cursosVisiveis" :key="c.id" class="curso-row">
                <span class="curso-label" :class="{ 'is-definido': !!metodos[c.id] }" :title="c.nome">{{ c.nome }}</span>
                <el-select :value="metodos[c.id] || ''" @change="alterar(c.id, $event)" style="width: 220px;">
                    <el-option v-for="op in opcoes" :key="op.v" :label="op.l" :value="op.v"></el-option>
                </el-select>
            </div>
            <div v-if="!cursosVisiveis.length" style="color: #909399;">Nenhuma série (curso) ativa encontrada.</div>
        </template>
    </div>
</template>

<script>
// Editor do parâmetro diario.metodo_avaliacao_por_curso (json {"<curso_id>": "quantitativo" | "qualitativo"}).
// Lista as séries (cursos) ativas de api/curso/getAllCurso; séries em "Padrão" ficam fora do objeto salvo.
export default {
    name: 'MetodoAvaliacaoCursoEditor',
    props: {
        p: { type: Object, required: true },
        valor: { default: null }
    },
    data () {
        return {
            cursos: [],
            carregando: false,
            metodos: {},
            opcoes: [
                { v: '',             l: 'Padrão (não definido)' },
                { v: 'quantitativo', l: 'Nota (quantitativo)' },
                { v: 'qualitativo',  l: 'Parecer (qualitativo)' }
            ]
        }
    },
    computed: {
        // Só cursos ativos; um inativo que já tenha método definido continua aparecendo para poder ser limpo.
        cursosVisiveis () {
            return this.cursos.filter(c => c.situacao === undefined || c.situacao === null || !!Number(c.situacao) || !!this.metodos[c.id])
        }
    },
    watch: {
        valor: { immediate: true, handler (v) { this.metodos = this.parse(v) } }
    },
    mounted () { this.carregar() },
    methods: {
        carregar () {
            this.carregando = true
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/curso/getAllCurso`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                this.cursos = r.data || []
                this.carregando = false
            }).catch(e => { this.carregando = false; this.$store.commit('throwException', e) })
        },
        parse (v) {
            if (!v) return {}
            try {
                const obj = typeof v === 'string' ? JSON.parse(v) : v
                if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return {}
                const res = {}
                Object.keys(obj).forEach(k => {
                    if (obj[k] === 'quantitativo' || obj[k] === 'qualitativo') res[k] = obj[k]
                })
                return res
            } catch (e) { return {} }
        },
        alterar (cursoId, metodo) {
            const novo = Object.assign({}, this.metodos)
            if (metodo) novo[cursoId] = metodo
            else delete novo[cursoId]
            this.metodos = novo
            this.$emit('save', novo)
        }
    }
}
</script>

<style scoped>
.curso-row {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 6px 4px;
    border-bottom: 1px solid #f5f5f5;
    max-width: 640px;
}
.curso-label {
    flex: 0 0 320px;
    font-size: 13px;
    color: #606266;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.curso-label.is-definido {
    color: #303133;
    font-weight: 600;
}
</style>
